import React, { useEffect, useState } from "react";

// import { HeaderComp } from "components";
import { Button, Container, TextField } from "@mui/material";
import { LocationOn, Mosque, MyLocation } from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import { useIsMounted } from "hooks";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { WithGeocode } from "App";

const Donate = (props) => {
  WithGeocode();

  const [currentLocation, setCurrentLocation] = useState({
    lat: "",
    lng: "",
    address: "",
  });

  const [currentCoordinates, setCurrentCoordinates] = useState({
    lat: "",
    lng: "",
  });

  const [mosqueAddress, setMosqueAddress] = useState({
    address: "",
    city: "",
    landmark: "",
    country: "",
    postalCode: "",
  });

  const location = useLocation();

  console.log(location?.state);

  const isMounted = useIsMounted();

  const getCity = (address) => {
    try {
      if (address?.length > 0) {
        for (let i = 0; i < address.length; i++) {
          let exist = address[i].types?.some((item) => {
            return item === "administrative_area_level_2";
          });
          if (exist) {
            // console.log(address[i].long_name);
            setMosqueAddress((prevState) => {
              return {
                ...prevState,
                city: address[i].long_name || "",
              };
            });
            return;
          }
          setMosqueAddress((prevState) => {
            return {
              ...prevState,
              city: "",
            };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPostalCode = (address) => {
    try {
      if (address?.length > 0) {
        for (let i = 0; i < address.length; i++) {
          let exist = address[i].types?.some((item) => {
            return item === "postal_code";
          });
          if (exist) {
            // console.log(address[i].long_name);
            setMosqueAddress((prevState) => {
              return {
                ...prevState,
                postalCode: address[i].long_name || "",
              };
            });
            return;
          }
          setMosqueAddress((prevState) => {
            return {
              ...prevState,
              postalCode: "",
            };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getCountry = (address) => {
    try {
      if (address?.length > 0) {
        for (let i = 0; i < address.length; i++) {
          let exist = address[i].types?.some((item) => {
            return item === "country";
          });
          if (exist) {
            // console.log(address[i].long_name);
            setMosqueAddress((prevState) => {
              return {
                ...prevState,
                country: address[i].long_name || "",
              };
            });
            return;
          }
          setMosqueAddress((prevState) => {
            return {
              ...prevState,
              country: "",
            };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCurrentLocation = () => {
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted") {
        navigator.geolocation.getCurrentPosition((position) => {
          console.log(position);
          setCurrentCoordinates({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      } else {
        alert(
          "Please turn on your location or allow permission to access your location for this site."
        );
        navigator.geolocation.getCurrentPosition((position) => {
          // console.log(position);
          setCurrentCoordinates({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      }
    });
  };

  const handleAddressSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        // console.log(address);
        setCurrentLocation({
          address: address,
          lat: latLng.lat,
          lng: latLng.lng,
        });
        setCurrentCoordinates({
          lat: latLng.lat,
          lng: latLng.lng,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  useEffect(() => {
    if (isMounted.current) {
      Geocode.fromLatLng(currentCoordinates.lat, currentCoordinates.lng).then(
        (response) => {
          console.log(response.results[0]);
          const address = response.results[0].formatted_address;
          console.log(address);
          getCity(response.results[0].address_components);
          getPostalCode(response.results[0].address_components);
          getCountry(response.results[0].address_components);
          setMosqueAddress((prevState) => {
            return {
              ...prevState,
              address: address,
            };
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [currentCoordinates, isMounted]);

  console.log(mosqueAddress);

  return (
    <main>
      {/* <header>
        <HeaderComp title="Donate Now" />
      </header> */}
      <section className="donate-now-main-section">
        <Container>
          <div className="donate-now-main-container">
            <div className="search-mosque-location w-100 flex-row align-items-center ">
              <div className="find-location-by-gps flex-row align-items-center gap-1">
                <span className="current-location">
                  {mosqueAddress?.city ||
                    mosqueAddress?.country ||
                    "Choose Location"}
                </span>
                <Button
                  className="mosque-gps-btn"
                  onClick={handleCurrentLocation}
                >
                  <MyLocation />
                </Button>
              </div>
              <div className="search-mosque-search-bar flex-row align-items-center w-100 relative">
                <PlacesAutocomplete
                  value={currentLocation.address}
                  onChange={(address) => {
                    setCurrentLocation({ ...currentLocation, address });
                  }}
                  onSelect={handleAddressSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div className="w-100">
                      <TextField
                        {...getInputProps({
                          placeholder: "Search for places",
                          className: "filter-by-location-search-input",
                        })}
                      />
                      <div className="autocomplete-dropdown-container">
                        {loading && <div>Loading...</div>}
                        {suggestions.map((suggestion, index) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                          // inline style for demonstration purpose
                          const style = suggestion.active
                            ? {
                                backgroundColor: "#f1f6ff",
                                cursor: "pointer",
                                padding: "5px",
                              }
                            : {
                                backgroundColor: "#f1f6ff",
                                cursor: "pointer",
                                padding: "5px",
                              };
                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                              key={index}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
                <Button className="search-map-btn"> Search </Button>
              </div>
            </div>
            <div className="donate-now-map w-100">
              {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.049693561855!2d85.77688741536465!3d20.25677371905741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a740ae304117%3A0x629ce9db127f69ef!2sSearchingYard%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1645098781035!5m2!1sen!2sin"
                  allowFullScreen=""
                  loading="lazy"
                  title="donate-now-map"
                  className="donate-now-g-map"
                ></iframe> */}

              <GoogleMapView
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={
                  <div style={{ height: `50vh` }} className="w-100 " />
                }
                mapElement={<div style={{ height: `100%` }} />}
                setCurrentCoordinates={setCurrentCoordinates}
                currentCoordinates={currentCoordinates}
              />
            </div>
            <div className="choose-from-map">
              <div className="mosque-info-title flex-row align-items-center gap-2 ">
                <span className="flex-row align-items-center">
                  <Mosque />
                </span>
                <span className="flex-column">
                  <h3 className="mosque-info-title-h3">Mosque Information</h3>
                  <p className="mosque-info-p">
                    Donate to the mosque of your choice
                  </p>
                </span>
              </div>
              <div className="mosque-info-name flex-row gap-2 align-items-center">
                <span className="flex-row align-items-center">
                  <Mosque />
                </span>
                <span className="mosque-info-name-title flex-column ">
                  <h3>Name of the mosque</h3>
                  <p>Not Selected</p>
                </span>
              </div>
              <div className="mosque-info-address flex-row gap-2 align-items-center">
                <span className="flex-row align-items-center">
                  <LocationOn />
                </span>
                <span className="mosque-info-address-title flex-column ">
                  <h3>Address</h3>
                  <p>{mosqueAddress?.address || "No address found"}</p>
                </span>
              </div>
              <div className="choose-the-mosque flex-row align-items-center justify-content-center">
                <NavLink to={"/ordernow"}>
                  <Button className="choose-mosque">Choose the mosque </Button>
                </NavLink>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Donate;

const GoogleMapView = withScriptjs(
  withGoogleMap((props) => {
    const handleMapClick = (event) => {
      let lat = event.latLng.lat();
      let lng = event.latLng.lng();
      props.setCurrentCoordinates({ lat, lng });
    };

    return (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: 24.774265, lng: 46.738586 }}
        center={{
          lat: props.currentCoordinates.lat || 24.774265,
          lng: props.currentCoordinates.lng || 46.738586,
        }}
      >
        <Marker
          position={{
            lat: props?.currentCoordinates?.lat || 24.774265,
            lng: props?.currentCoordinates?.lng || 46.738586,
          }}
          onClick={handleMapClick}
          onDragEnd={handleMapClick}
          draggable={true}
        />
      </GoogleMap>
    );
  })
);
